import React, { createContext, useContext } from 'react';

import invariant from 'tiny-invariant';

import type { GlobalDashboardRegistry } from './registries/dashboard-registries/types';

export type DashboardContextProps = {
  registry: GlobalDashboardRegistry;
};

const DashboardContext = createContext<DashboardContextProps | null>(null);

const ERROR_MESSAGE =
  'must be used within an InsightsDashboardRegistryProvider.';

export const useDashboardRegistry = (): GlobalDashboardRegistry => {
  const ctx = useContext(DashboardContext);
  invariant(ctx, ERROR_MESSAGE);
  return ctx.registry;
};

export const InsightsDashboardRegistryProvider = ({
  children,
  value,
}: React.PropsWithChildren<{ value: DashboardContextProps }>) => {
  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};
